import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const imageGalleryEntity: Entity = {
  model: model,
  repository: repository,
}

export default imageGalleryEntity
